import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import GotQuestion from "../Courses/GotQuestion";
import Faq from "../Courses/FAQ";
import { Helmet } from "react-helmet";

const HealthInsuarance = () => {
  const [faqs, setFaqs] = useState([]);
  const [courses, setCourses] = useState([]);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  useEffect(() => {
    const checkData = async () => {
      const app = { slug: "HealthInsuarance" };
      const result = await getApiData("api/get_faq", app);
      if (result && result.status === 200) {
        const filteredFaqs = result.data.filter(
          (faq) => faq.slug === "HealthInsuarance"
        );
        setFaqs(filteredFaqs);
      }
    };
    checkData();
  }, []);

  const healthPartners = [
    {
      name: "BUPA",
      text: "Bupa, officially known as the British United Provident Association Limited, is a global leader in health insurance and healthcare services, catering to over 38 million customers worldwide. Renowned for its extensive network and high-quality offerings, Bupa provides comprehensive health insurance plans tailored to meet the diverse needs of international students, visitors, and workers in Australia.",
      logo: "https://www.pfecglobal.com.au/wp-content/uploads/sites/2/2022/06/bupa-svg.svg",
    },
    {
      name: "AHM by Medibank",
      text: "With over 40 years of experience, AHM by Medibank is a trusted name in Australian health insurance. Known for its no-nonsense approach, AHM simplifies the insurance process, making it easier for clients to maximize their coverage. Their straightforward plans are designed to provide effective and affordable solutions for individuals and families.",
      logo: "https://www.pfecglobal.com.au/wp-content/uploads/sites/2/2022/06/ahm.svg.svg",
    },
    {
      name: "Allianz",
      text: "Allianz, a German multinational insurance and financial services provider, is one of the largest insurers in the world. With its headquarters in Munich, Germany, Allianz offers flexible and reliable health insurance options. It is a trusted partner for those seeking comprehensive coverage for medical and hospital expenses while in Australia.",
      logo: "https://res.cloudinary.com/dnu4huav1/images/f_auto,q_auto/v1711797291/Allianz-01/Allianz-01.png?_i=AA",
    },
    {
      name: "Medibank",
      text: "Medibank Private Limited, commonly referred to as Medibank, is one of Australia’s largest private health insurance providers. Serving 3.7 million individuals in 2021, Medibank offers a wide range of healthcare solutions, ensuring that international students, visitors, and workers receive the coverage they need to access high-quality healthcare services during their stay in Australia.",
      logo: "https://www.pfecglobal.com.au/wp-content/uploads/sites/2/2022/06/Medibank.svg.svg",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const result = await getApiData("api/get_health_insurance", {});
      if (result && result.status === 200) {
        const filteredCourses = result.data.filter(
          (course) => course.slug === "HealthInsuarance"
        );
        setCourses(filteredCourses);
        setContentLoaded(true);

        if (filteredCourses.length > 0) {
          const selectedCourse = filteredCourses[0];

          // Ensure the meta tags are only set if the slug is correct
          if (selectedCourse.slug === "HealthInsuarance") {
            setMetaTitle(selectedCourse.meta_title);
            setMetaKeywords(selectedCourse.meta_keyword);
            setMetaDescription(selectedCourse.meta_description);
          }
        }
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>
      {/* hero banner section */}
      {courses.length > 0 ? (
        courses.map((course, index) => (
          <section
            key={index}
            className="inner-banner relative min-h-[77vh] w-full overflow-hidden"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${course.banner})`,
              }}
            ></div>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-y-0 left-8 sm:left-8 lg:left-24 flex items-center">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white mb-4 sm:mb-0">
                <span
                  className="block font-black text-5xl sm:text-6xl lg:text-7xl"
                  dangerouslySetInnerHTML={{ __html: course.banner_title }}
                />
              </h2>
            </div>
            <div className="absolute bottom-14 sm:bottom-7 lg:bottom-36 right-4 sm:right-8 px-4 w-full sm:w-4/5 md:w-3/5 lg:w-2/5 text-right">
              <p className="text-white subhead-main font-size-low">
                {course.banner_subtitle}
                <span className="desktop-break">
                  <br />
                </span>
                {course.banner_subtitle2}
              </p>
            </div>
          </section>
        ))
      ) : (
        <div className="text-center py-20 text-white">
          <p>Loading data...</p>
        </div>
      )}

      {/* Space between the sections*/}
      <div className="block sm:hidden bg-[#ffff] h-16"></div>

      {/* Photo with text section */}
      {courses.length > 0 &&
        courses.map((course, index) => (
          <section
            key={index}
            className="business-studies-about min-h-screen w-full bg-[#ffff]"
          >
            <div className="container-fluid w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 min-h-screen gap-4 place-items-center">
                {/* Left Column - Dynamic Image */}
                <div className="w-full flex justify-center sm:justify-start sm:items-start">
                  <div className="business-studies-about__contents__wrapper-image w-full sm:w-3/4 md:w-2/3 h-full">
                    <img
                      className="w-full h-full object-cover"
                      src={course.section1_image}
                      alt="Construction Section"
                    />
                  </div>
                </div>

                {/* Right Column - Dynamic Text */}
                <div className="w-full flex justify-center sm:justify-start sm:items-start">
                  <div className="business-studies-about__contents__text text-black p-6 sm:p-12">
                    <p
                      className="subhead-main color-black"
                      dangerouslySetInnerHTML={{ __html: course.section1_desc }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}

      {/* Health care section */}
      {courses.length > 0 &&
        courses.map((course, index) => (
          <section key={index}>
            <div className="p-4 max-w-7xl mx-auto">
              <section className="mt-8">
                <h2 className="text-center mb-8">
                  {course.healthcare_plans_title}
                </h2>

                {/* OSHC Section */}
                <section className="bg-[#FFFBF6] p-6 rounded-lg mb-6">
                  <h2 className="text-center text-[#4BBA89] mb-4 main-title">
                    {course.healthcare_plans1_subtitle}
                  </h2>
                  <p
                    className="subhead"
                    dangerouslySetInnerHTML={{
                      __html: course.healthcare_plans1_desc,
                    }}
                  ></p>
                </section>

                {/* OVHC Section */}
                <section className="bg-[#FFFBF6] p-6 rounded-lg">
                  <h2 className="text-center text-[#4BBA89] mb-4 main-title">
                    {course.healthcare_plans2_subtitle}
                  </h2>
                  <p
                    className="subhead"
                    dangerouslySetInnerHTML={{
                      __html: course.healthcare_plans2_desc,
                    }}
                  ></p>
                </section>
              </section>
            </div>
          </section>
        ))}

      {/* Testimonials section */}
      {contentLoaded && (
        <section className="section">
          <div className="container">
            <div className="max-w more" style={{ marginBottom: "20px" }}>
              <div className="flex-tag">
                <div className="bullet-tag color"></div>
                <h2>Our Trusted Health Insurance Partners</h2>
              </div>
            </div>
            <Swiper
              spaceBetween={15}
              slidesPerView={1}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Pagination, Autoplay]}
              loop={true}
            >
              {healthPartners.map((partner, index) => (
                <SwiperSlide key={index}>
                  <div className="w-full flex justify-center">
                    <div
                      className="shadow-lg rounded-lg p-4 w-full max-w-sm"
                      style={{ backgroundColor: "#FFFBF6" }}
                    >
                      {/* Header Section */}
                      <div className="text-center mb-4">
                        <h2 className="text-xl font-bold text-gray-800">
                          {partner.name}
                        </h2>
                        <h5 className="text-sm text-gray-600">
                          Insurance Company
                        </h5>
                      </div>

                      {/* Image Section */}
                      <div className="flex justify-center mb-4">
                        <img
                          className="w-24 h-24 object-contain"
                          src={partner.logo}
                          alt={`${partner.name} Logo`}
                        />
                      </div>

                      {/* Footer Section */}
                      <div className="text-center">
                        <p className="subhead">{partner.text}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

      {/* FAQ Section */}
      {contentLoaded && <Faq faqs={faqs} />}

      {/* got a question Section */}
      {contentLoaded && <GotQuestion />}
    </>
  );
};

export default HealthInsuarance;
